<template lang="html">
<div class="inner-page">
     <Header>专辑</Header>
     <div class="scroll-list" :style="'height:' + scrollH + 'px'">
           <div class="album-dets">
                <div class="imgs"> <img :src="preDat[0].coverImage" alt=""> </div>
                <div class="album-content">
                     <div class="c-name">{{preDat[0].firstTitle}}</div>
                     <div class="e-name">{{preDat[0].foreignTitle}}</div>
                     <div class="icons">
                          <div class="iconGp" @click="goPlay">
                                <van-icon class="icon" class-prefix="iconfont" name="play2" />
                                <span>播放</span>
                          </div>
                          <div class="iconGp" @click="albumCollect">

                               <div class="icon2" v-if="collectId">
                                      <van-icon class="icon" class-prefix="iconfont" name="collected2" />
                                      <span>取消收藏</span>
                               </div>
                               <div v-else>
                                      <van-icon class="icon" class-prefix="iconfont" name="collect" />
                                      <span>收藏</span>
                               </div>

                          </div>
                          <div class="iconGp" @click="share">
                                <van-icon class="icon" class-prefix="iconfont" name="share" />
                                <span>分享</span>
                          </div>
                     </div>
                </div>
           </div>
           <div class="album-infos">
                <div class="infos-ttl">专辑详情</div>
                <div :class="['infos-content',{'act':moreState}]">
                     <div class="content-line">资料类型：{{preDat[0].speed | nullSet}}</div>
                     <div class="content-line">出版者：{{preDat[0].publish | nullSet}}</div>
                     <div class="content-line">出版时间：{{preDat[0].publishYears | nullSet}}</div>

                     <div class="content-line">出版序号：{{infos[0]['出版编号'] | nullSet}}</div>
                     <div class="content-line">母盘编号：{{infos[0]['母盘编号'] | nullSet}}</div>
                     <div class="content-line">再版时间：{{infos[0]['再版时间'] | nullSet}}</div>
                     <div class="content-line">材质：{{infos[0]['材质'] | nullSet}}</div>
                     <div class="content-line">尺寸：{{infos[0]['尺寸'] | nullSet}}</div>
                     <div class="content-line">保存状况：{{infos[0]['保存状况'] | nullSet}}</div>
                </div>
                <div class="infos-more" @click="moreLines">
                     <span v-if="moreState">收起</span>
                     <span v-else>查看更多</span>
                     <van-icon :class="['icon',{'act':moreState}]" class-prefix="iconfont" name="slideOpen" />
                </div>
           </div>
<!--           <Albumlist class="album-list" :listDat="albumList[0]" :albumId="albumId" />-->
           <Albumlist class="album-list" :listDat="albumList[0]" :albumId="albumId" :account="account" :pwd="pwd"/>
           <Search class="search" />
           <Footer/>
     </div>
</div>
</template>

<script>
import Albumlist from "./src/albumList";
import Search from "@/components/Search";
import vEmits from "@/utils/vEmits";
import { getAlbumDets,getAlbumList } from '@/api/album';
import { goCollect,unCollect } from "@/api/me";

export default {
     components:{
          Albumlist,
          Search
     },
     filters:{
          nullSet:function(e){
               if(e){
                   return e;
               }else{
                   return '/';
               }
          }
     },
     data(){
          return{
              albumId:'',
              preDat:[{}],
              infos:[{}],
              moreState:false,
              albumList:[[]],
              scrollH:'',
              collectId:'',
              account:this.$route.query.account,
              pwd:this.$route.query.pwd,
          }
     },
     methods:{
          getAlbumDets:function(){
               getAlbumDets({albumId:this.albumId}).then(res => {
                   this.preDat.splice(0,1,res.materialAlbum);
                   this.infos.splice(0,1,JSON.parse(res.materialAlbum.info));
                   this.collectId = res.materialAlbum.collectFlag;
               }).catch(errs => {
                   window.console.log(errs);
               })
          },
          getAlbumList:function(){
              getAlbumList({albumId:this.albumId}).then(res => {
                   this.albumList.splice(0,1,res.materialSingleList);
              }).catch(errs => {
                  window.console.log(errs);
              });
          },
          moreLines:function(){
               this.moreState = !this.moreState;
          },
          goPlay:function(){
               this.push({
                   path:'song',
                   query:{
                        icd:this.albumList[0][0].id,
                        iab:this.albumId,
                        account:this.account,
                        pwd:this.pwd,
                   }
               })
          },
          albumCollect:function(){
                let userId = this.$store.state.user.userId;
                let lgtype = this.$store.state.user.lgtype;
                let vues = this;
                if(userId){
                    if(this.collectId){
                         unCollect({
                              id:vues.collectId
                         }).then(res => {
                             window.console.log(res);
                              vues.collectId = '';
                              vEmits.$emit('show','已取消收藏');
                         })
                    }else{
                         goCollect({
                              materialId:vues.albumId,
                              modelType:1,
                              userId:userId
                         }).then(res => {
                             vues.collectId = res.collectId;
                             vEmits.$emit('show','收藏成功');
                         })
                    }
                }else if(lgtype == 'ip'){
                    vEmits.$emit('show','非个人登录状态下无法进行收藏');
                }else{
                    vEmits.$emit('show','请先登录');
                }
          },
          share:function(){
                let vues = this;
                vues.$copyText(window.location.href).then(function(){
                    vEmits.$emit('show','已复制至粘贴板');
                },function(){

                })
          }
     },
     created:function(){
          this.albumId = this.$route.query.iab;
          this.getAlbumDets();
          this.getAlbumList();
          this.scrollH = document.documentElement.clientHeight - 105;
     },
}
</script>

<style lang="css" scoped>

.scroll-list{
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
}

.album-dets{
    margin: 0 10px;
    display: flex;
    align-items: center;
}

.album-dets .imgs{
    height: 110px;
    width: 110px;
    margin: 12px 0;
    background: white;
    flex-shrink: 0;
}

.album-dets .imgs img{
    height: 110px;
    width: 110px;
}

.album-dets .album-content{
    margin-left: 10px;
    flex-grow: 1;
}

.album-dets .icons{
    display: flex;
    margin-top: 12px;
    justify-content: space-between;
}

.album-dets .c-name{
    font-size: 16px;
}

.album-dets .e-name{
    font-size: 14px;
    color: #666666;
    margin-top: 5px;
}

.album-dets .icons .icon{
    margin-right: 3px;
    vertical-align: middle;
}

.album-dets .icons span{
    font-size: 14px;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 2px;
}

.album-dets .iconGp:nth-child(2) .icon{
   font-size: 17px;
}

.album-dets .icon2{
   color: #af2d2d;
}

.album-dets .icon2 .icon{
  color: #af2d2d;
}

/* 详情 */

.album-infos{
    background: white;
    padding: 12px 10px;
}

.infos-ttl{
    font-weight: bold;
}

.album-infos .content-line{
    font-size: 14px;
    margin-top: 9px;
    color: #666666;
}

.infos-more{
    height: 45px;
    text-align: center;
    line-height: 45px;
    color: #666666；
}

.infos-more .icon{
    position: relative;
    font-size: 24px;
    display: inline-block;
    vertical-align: middle;
    -webkit-transform: rotate(0deg);

    transition-property: all;
    transition-duration: 0.2s;
}

.infos-more .icon.act{
    -webkit-transform: rotate(180deg);
}

.infos-more span{
  display: inline-block;
  vertical-align: middle;
}

.infos-content{
   overflow: hidden;
   height: 90px;
   position: relative;
   transition-property: all;
   transition-duration: 0.2s;
}

.infos-content.act{
   height: 270px;
}

/* 列表 */

.album-list{
    background: white;
    margin-top: 6px;
    padding-top: 12px;
}

.search{
    padding-top: 30px;
    margin-bottom: -1px;
}

</style>
